import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSelectedIssueData } from '../../store/Actions/SelectedIssue/SelectedIssue';
import AdminHelpScreen from '../../components/AdminHelp/AdminHelp';

const AdminHelp = () => {
  const dispatch = useDispatch();
  const selected = useSelector((store) => store.selectedIssue.selectedIssue);
  const [status, setStatus] = useState(selected.status ? selected.status : '');
  const issueId = window.location.pathname.split('/').pop();

  const updateIssueStatus = (value) => {
    setStatus(value);
  };

  useEffect(() => {
    dispatch(fetchSelectedIssueData());
  }, [status]);

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <AdminHelpScreen
            selected={selected}
            Id={issueId}
            updateIssueStatus={updateIssueStatus}
          />
        </Col>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  float: left;
  background: #fff;
  @media only screen and (max-width: 2400px) {
    width: 66%;
    height: 100%;
    position: relative;
    float: none;
    margin: 0 auto;
  }
  @media only screen and (max-width: 800px) {
    width: 90% !important;
    height: 100%;
    position: relative;
    float: none;
    margin: 0 auto;
    background: #fff;
  }
`;

export default AdminHelp;
